export const header = () => {


	//Hide the header as the users scrolls down, reveal it again if they scroll up
	let pageHeader = document.querySelector('#main-header'),
	scrollTrigger = pageHeader.offsetHeight;


	//Piggybacking extra code here to handle the 'Quick Links' lsubnav module on mobile (and filters from stories & press feeds)
	let lsubnavModule = document.querySelector('.m__lsubnav');
	let sfeedMobileFilters = document.querySelector(".js__sfeed__filters");
	let pfeedMobileFilters = document.querySelector(".js__pfeed__filters");


	document.addEventListener('scroll', (event) => {

		if(window.scrollY > scrollTrigger){
				pageHeader.classList.add('header-scrolled');
		}else{
			pageHeader.classList.remove('header-scrolled');
			
		}
		
  		
	});

	
}